import { useQuery } from "@apollo/client";
import { Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import moment from "moment";
import { useEffect, useState } from "react";
import "../../App.css";
import { GET_ADJUST_IN_REPORT } from "../../Schema/Report";
import { EmptyTr } from "../Include/EmptyData";
import { LoadingTr } from "../Include/LoadingPage";

const adjustinReason = (value) => {
  if (value === "free") {
    return "ឥតគិតថ្លៃ";
  } else if (value === "from_use") {
    return "ពីការប្រើប្រាស់";
  } else if (value === "production") {
    return "ផលិត";
  } else if (value === "lack") {
    return "រាប់ខ្វះ";
  } else {
    return value;
  }
};
export default function ReportAdjustIn({
  startDate,
  endDate,
  meterialId,
  warehouseValId,
  reason,
}) {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);

  useQuery(GET_ADJUST_IN_REPORT, {
    variables: {
      warehouseIds: warehouseValId ? [warehouseValId] : [],
      materialIds: meterialId ? meterialId : [],
      listMaterialUnitIds: [],
      supplierIds: [],
      from: startDate ? dayjs(startDate)?.format("YYYY-MM-DD") : "",
      to: endDate ? dayjs(endDate)?.format("YYYY-MM-DD") : "",
      reasons: reason === "all" ? [] : [reason],
    },
    onCompleted: ({ getAdjustInReport }) => {
      // console.log("getAdjustInReport:::", getAdjustInReport);
      setTableData(getAdjustInReport);

      if (getAdjustInReport?.length > 0) {
        let total = 0;
        getAdjustInReport?.forEach((row) => {
          total += row?.qty * row?.unitPrice;
        });
        setTotalAmount(total);
      } else setTotalAmount(0);

      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::getAdjustInReport", err?.message);
    },
  });

  useEffect(() => {
    setLoading(true);
  }, [startDate, endDate, meterialId, warehouseValId, reason]);

  return (
    <>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        marginTop="25px"
      >
        <Typography className="report-title-kh">
          របាយការណ៍កែប្រែទំនិញចូលឃ្លាំង
        </Typography>
        <Typography className="report-title-en">
          {`${moment(startDate)?.format("DD-MM-YYYY")} - ${moment(endDate)?.format("DD-MM-YYYY")}`}
        </Typography>
      </Stack>

      <div className="report-table-scroll-container">
        <table className="report-table">
          <tbody>
            <tr>
              <td className="report-table-th-sticky" align="center" width="2%">
                ល.រ
              </td>
              <td className="report-table-th-sticky" align="center">
                កាលបរិច្ឆេទ
              </td>
              <td className="report-table-th-sticky" align="center">
                ឃ្លាំង
              </td>
              <td className="report-table-th-sticky" align="center">
                បរិយាយ
              </td>
              <td className="report-table-th-sticky" align="center">
                មូលហេតុ
              </td>
              <td className="report-table-th-sticky" align="center">
                ខ្នាត
              </td>
              <td className="report-table-th-sticky" align="center">
                ចំនួន
              </td>
              {/* <td className="report-table-th-sticky">
                តម្លៃរាយ
              </td>
              <td className="report-table-th-sticky">
                សរុប
              </td> */}
            </tr>
          </tbody>

          <tbody className="report-table-body">
            {loading ? (
              <LoadingTr colSpan={7} />
            ) : !tableData?.length ? (
              <EmptyTr colSpan={7} />
            ) : (
              tableData?.map((row, index) => {
                return (
                  <tr key={index}>
                    <td className="report-table-body-td-center">{index + 1}</td>

                    <td className="report-table-body-td-center">
                      {moment(row?.adjustInId?.createdAt)?.format(
                        "DD-MM-YYYY hh:mm a",
                      )}
                    </td>

                    <td className="report-table-body-td-center">
                      {row?.adjustInId?.warehouseId?.warehouseName}
                    </td>

                    <td className="report-table-body-td-left">
                      {row?.listMaterialUnitId?.materialId?.materialKhName}
                    </td>

                    <td className="report-table-body-td-center">
                      {adjustinReason(row?.adjustInId?.reason)}
                    </td>

                    <td className="report-table-body-td-center">
                      {row?.listMaterialUnitId?.unitId?.unitKhName}
                    </td>

                    <td className="report-table-body-td-center">{row?.qty}</td>

                    {/* <td className="report-table-body-td-center">
                      <Stack direction="row" justifyContent="space-between">
                        <Typography className="text-field-cost-unit">
                          $
                        </Typography>
                        <Typography className="text-field-cost-unit">
                          {row?.unitPrice > 0 ? (row?.unitPrice)?.toFixed(2) : '-'}
                        </Typography>
                      </Stack>
                    </td>

                    <td className="report-table-body-td-center">
                      <Stack direction="row" justifyContent="space-between">
                        <Typography className="text-field-cost-unit" color="blue">
                          $
                        </Typography>
                        <Typography className="text-field-cost-unit" color="blue">
                          {row?.unitPrice * row?.qty > 0 ? (row?.unitPrice * row?.qty)?.toFixed(2) : '-'}
                        </Typography>
                      </Stack>
                    </td> */}
                  </tr>
                );
              })
            )}

            {/* <tr>
              <td colSpan={7} className="report-table-tbody-td-total-total"></td>
              <td className="report-table-tbody-td-total-total">
                សរុប
              </td>
              <td className="report-table-tbody-td-total-cost" align="center" style={{ fontWeight: 'bold' }}>{totalQty?.totalGive ?? '0.00'}</td>
              <td className="report-table-tbody-td-total-cost" align="center" style={{ fontWeight: 'bold' }}>{totalQty?.totalSell ?? '0.00'}</td>
              <td className="report-table-tbody-td-total-cost" align="center" style={{ fontWeight: 'bold' }}>{totalQty?.total ?? '0.00'}</td>
            </tr> */}

            {/* <tr>
              <td className="report-table-body-td-center" colSpan={7}></td>
              <td className="report-table-body-td-left">
                សរុប
              </td>

              <td className="report-table-body-td-left">
                <Stack direction="row" justifyContent="space-between">
                  <Typography className="text-field-cost-unit" color="blue">
                    $
                  </Typography>
                  <Typography className="text-field-cost-unit" color="blue">
                    {totalAmount > 0 ? (totalAmount)?.toFixed(2) : '-'}
                  </Typography>
                </Stack>
              </td>
            </tr> */}
          </tbody>
        </table>
      </div>
    </>
  );
}
